import { Modal, Typography } from '@smartgift/frontend-toolkit';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function FeeBreakdownInfoModal({ isOpen, onRequestClose }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      primaryButtonProps={{ onClick: onRequestClose }}
      title={t('feesBreakdown')}
      size="sm"
    >
      <S.FeeBreakdownInfoModalWrapper>
        <S.ItemWrapper>
          <Typography variant="body1Bold">{t('shippingFee')}</Typography>
          <Typography variant="body2">{t('feeBreakdownModalShippingDesc')}</Typography>
        </S.ItemWrapper>
        <S.ItemWrapper>
          <Typography variant="body1Bold">{t('serviceFee')}</Typography>
          <Typography variant="body2">{t('feeBreakdownModalServiceDesc')}</Typography>
        </S.ItemWrapper>
      </S.FeeBreakdownInfoModalWrapper>
    </Modal>
  );
}

export { FeeBreakdownInfoModal };
